import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  Output,
  QueryList,
  TemplateRef,
  EventEmitter,
} from '@angular/core';
import { CellTemplateDirective } from './cell-template.directive';
import { PageEvent } from '@angular/material/paginator';
import { OrderDirection, Pagination } from '@/models/pagination.model';

export interface DatatableColumn {
  field: string;
  label: string;
  propertyName?: string;
  format?: (data: any) => string | number;
  type?: string;
  orderable?: boolean;
}

export interface Sorting {
  [key: string]: OrderDirection;
}

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
})
export class DatatableComponent implements AfterContentInit {

  @Input() displayPagination: boolean = true;
  @Input() columns: DatatableColumn[] = [];
  @Input() paginationProps!: Pagination<any>;
  @Input() showHeader: boolean = true;

  @Output() updateSorting = new EventEmitter<Sorting>();
  @Output() updatePage = new EventEmitter<PageEvent>();

  @ContentChildren(CellTemplateDirective)
  cellTemplates!: QueryList<CellTemplateDirective>;
  cellTemplatesMap!: { [key: string]: TemplateRef<any> };
  sorting: Sorting = {};
  pageLengths = [10, 25, 50, 75, 100];

  transformValue(item: any, value: string) {
    if (!value.includes('.')) {
      return item[value];
    }
    const stringArr = value.split('.');
    return stringArr.reduce((acc, current) => {
      return acc[current];
    }, item);
  }

  pageChange(pageEvent: PageEvent) {
    this.updatePage.emit(pageEvent);
  }

  changeSorting(fieldName: string) {
    let sort = this.sorting[fieldName];
    if (!sort) {
      this.sorting[fieldName] = OrderDirection.ASC;
    } else {
      if (sort == OrderDirection.ASC) {
        this.sorting[fieldName] = OrderDirection.DESC;
      } else {
        delete this.sorting[fieldName];
      }
    }

    this.updateSorting.emit(this.sorting);
  }

  ngAfterContentInit() {
    this.cellTemplatesMap = this.cellTemplates.reduce((acc, current) => {
      acc[current.name] = current.template;
      return acc;
    }, {} as { [key: string]: TemplateRef<any> });
  }

  getStatusClass(): string {
    if (!this.showHeader) {
      return 'table_container_white'
    } else {
      return 'table_container'
    }
  }
}
